module.exports = __webpack_public_path__ + "static/seller/img/seo-r.f4beb995.png";